import React from 'react';
import PropTypes from 'prop-types';
import { useLayout } from '../layout/context';
// Styles
import { Container } from '../styled/containers';
import { Header, Wrapper, StyledLinkHandler } from './styles';

const Banner = ({ headerText, linkText, link, removeMarginBottom }) => {
  const { insideSideBar } = useLayout();
  return (
    <Wrapper $removeMarginBottom={removeMarginBottom} sidebar={insideSideBar}>
      <Container>
        <Header as={insideSideBar ? 'h3' : 'h2'}>{headerText}</Header>
        {link && <StyledLinkHandler link={link}>{linkText}</StyledLinkHandler>}
      </Container>
    </Wrapper>
  );
};

Banner.propTypes = {
  headerText: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  internalLink: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
  }),
  removeMarginBottom: PropTypes.bool,
  link: PropTypes.object,
};

export default Banner;

export const BannerAssembly = ({ contentfulData }) => (
  <Banner
    headerText={contentfulData.headerText}
    linkText={contentfulData.linkText}
    internalLink={contentfulData.internalLink}
    removeMarginBottom={contentfulData.removeMarginBottom}
    link={contentfulData.link && contentfulData.link[0]}
  />
);

BannerAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
